export const CONTAINER_MAX_WIDTH = '560px';
